import { transition, trigger, useAnimation } from '@angular/animations';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TemperatureLocationModel } from './temperature-store/temperature.actions';

import { pulseUpdate } from '../../../shared/animations/pulse.animation';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-temperature-ui',
  templateUrl: './temperature.component.html',
  styleUrls: ['./temperature.component.scss'],
  animations: [trigger('pulse', [transition('* => *', [useAnimation(pulseUpdate)])])],
})
export class TemperatureComponent {
  readonly temperature = input.required<TemperatureLocationModel>();
}
